/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import React from 'react';
import { IProofPointViewProps } from './proof-point';

export default (props: IProofPointViewProps) => {
    const { proofPointsNode } = props;
    return <>{proofPointsNode}</>;
};
